module.exports = __webpack_public_path__ + "assets/img/media_21.67f19f23.png";